<header>Sign In</header>
<div class="header-text">Welcome back, sign into your account securely!</div>

<button class="google-login" (click)="authService.googleLogin()" type="button">
  <img class="button-icon" src="assets/imgs/GoogleIcon.webp" alt="Google Logo" /><span>Login with Google</span>
</button>

<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div class="email">
    <mat-form-field appearance="outline">
      <mat-label>Email address</mat-label>
      <input matInput id="email" type="email" formControlName="email" />
      <mat-error *ngIf="email?.errors">Please enter a valid email address.</mat-error>
    </mat-form-field>
  </div>

  <div class="password">
    <mat-form-field appearance="outline">
      <mat-label>Password</mat-label>
      <input matInput id="password" type="passsword" formControlName="password" />
      <mat-error *ngIf="password?.errors!['required']">Please enter your password.</mat-error>
      <mat-error *ngIf="password?.errors!['minlength']">Password must be at least {{password.errors!['minlength']['requiredLength']}} characters long.</mat-error>
    </mat-form-field>
  </div>

  <button mat-flat-button color="primary" type="submit" [disabled]="loginForm.invalid">Log In</button>
</form>

<a class="forgot-pass" [routerLink]="nav_path.forgotPassword">Forgot Password?</a>

<div class="sign-up">
  Don't have an account?
  <a class="sign-up-button" [routerLink]="nav_path.signUp">Sign Up</a>
</div>
